/**
 *
 * @param {number} sizeInMb File size in MB
 * - defaults to `25` as common max file upload size
 *
 * @returns {number} File size in Bytes
 */
export const DEFAULT_UPLOAD_FILE_SIZE = 25
export const FORMATTED_DEFAULT_UPLOAD_SIZE = DEFAULT_UPLOAD_FILE_SIZE.toFixed(1)

export const formatMbToBytes = (sizeInMb?: number): number => {
  const kbToBytes = 1024 * 1024

  return (sizeInMb ?? DEFAULT_UPLOAD_FILE_SIZE) * kbToBytes
}
